export const bgColorIcon = `
<svg fill="currentColor" viewBox="1 1 27 27">
  <g fill="none" fill-rule="evenodd">
    <path d="M4 0h22a4 4 0 0 1 4 4v22a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4Z"/>
    <path fill="currentcolor" d="M20.899 16.351c.787-.471.892-1.567.316-3.287 1.02 1.078 1.634 2.067 1.839 2.969.308 1.352.051 2.183-.475 2.7-.59.581-1.536.581-2.126 0-.526-.517-.735-1.675.446-2.382ZM20.49 13.753l-6.724 6.61-5.763-5.669 11.002-.94z"/>
    <path stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.765 20.363 8 14.689l6.728-6.61 5.765 5.674zM16.925 10.242 12.614 6"/>
    <path style="color:var(--ex-color, currentColor)" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M8.947 23.053h11.102"/>
  </g>
</svg>
`;
//# sourceMappingURL=icon.js.map